export const triggerDelayedResize = () => {
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 250);
};